<template>
	<div>
		<div class="flex-end" style="margin-bottom: 20px;">
			<h3>数据日期：</h3>
			<div style="margin: 0 20px;">
				<el-radio-group size='small' v-model="tabPosition" @change="changeDays">
					<el-radio-button label="yes">昨天</el-radio-button>
					<el-radio-button label="week">近7天</el-radio-button>
					<el-radio-button label="month">近30天</el-radio-button>
				</el-radio-group>
			</div>
			<el-date-picker v-model="dataForm.staticTimes" @change="staticTimesChange" format='yyyy-MM-dd'
				value-format='yyyy-MM-dd' size='small' type="datetimerange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期">
			</el-date-picker>
		</div>
		<div class="flex-b flex-only">
			<div class="w-49">
				<div class="flex flex-b">
					<el-card shadow="never" class="w-49 card" style="height: 165px;">
						<div class="flex">
							<img src="../../assets/dd.png" style="width: 60px;height: 60px;" />
							<div style="margin-left: 30px;">
								<div class="title">订单数量(笔)</div>
								<div class="val">{{staticsData.total_num}}</div>
							</div>
						</div>
					</el-card>
					<el-card shadow="never" class="w-49 card" style="height: 165px;">
						<div class="flex">
							<img src="../../assets/jy.png" style="width: 60px;height: 60px;" />
							<div style="margin-left: 30px;">
								<div class="title">交易流水(元)</div>
								<div class="val">{{staticsData.total_price}}</div>
							</div>
						</div>
						<div class="mxbtn pointer" @click="editdialogVisible = true">明细</div>
					</el-card>
				</div>

				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;height: 500px;">
					<div slot="header" class="clearfix flex flex-b cardHeader">
						<h4>营收统计</h4>
						<div class="flex">
							<el-select size="small" style="width: 100px;" @change="changeType" v-model="dataForm.type"
								placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
								value-format='yyyy-MM-dd' v-model="dataForm.times" @change="ysTimesChange"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="chart-container">
						<div ref="chart" style="width: 100%; height: 400px;"></div>
					</div>
				</el-card>
				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;height: 500px;">
					<div slot="header" class="clearfix flex flex-b">
						<h4>收入分析</h4>
						<div class="flex">
							<el-select size="small" style="width: 100px;" @change="changeType1" v-model="dataForm.type1"
								placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-date-picker size="small" style="margin-left: 20px;width: 250px;" @change="syTimesChange"
								format='yyyy-MM-dd' value-format='yyyy-MM-dd' v-model="dataForm.times1"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="chart-container">
						<div ref="chart1" style="width: 100%; height: 400px;"></div>
					</div>
				</el-card>
			</div>
			<div class="w-49">
				<div class="headCard">
					<el-card shadow="never" class="box-card br-10px" style="height: 165px;">
						<div slot="header" class="clearfix flex flex-b cardHeader">
							<el-tabs v-model="activeName">
								<el-tab-pane label="会员" name="first"></el-tab-pane>
								<el-tab-pane label="培训" name="second"></el-tab-pane>
							</el-tabs>
						</div>
						<div class="flex flex-a" v-if="activeName == 'first'">
							<div class="flex">
								<img src="../../assets/dd.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="title" style="font-size: 14px;">会员订单数(笔)</div>
									<div class="val" style="font-size: 32px;">{{staticsData.member_order_num}}</div>
								</div>
							</div>
							<div class="flex">
								<img src="../../assets/jy.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="title" style="font-size: 14px;">会员成交金额(元)</div>
									<div class="val" style="font-size: 32px;">{{staticsData.member_order_price}}</div>
								</div>
							</div>
						</div>
						<div class="flex flex-a" v-else>
							<div class="flex">
								<img src="../../assets/dd.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="title" style="font-size: 14px;">培训订单数(笔)</div>
									<div class="val" style="font-size: 32px;">{{staticsData.train_order_num}}</div>
								</div>
							</div>
							<div class="flex">
								<img src="../../assets/jy.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="title" style="font-size: 14px;">培训成交金额(元)</div>
									<div class="val" style="font-size: 32px;">{{staticsData.train_order_price}}</div>
								</div>
							</div>
						</div>
					</el-card>
				</div>
				<el-card shadow="never" class="box-card br-10px" style="height: 1015px;margin-top: 15px;">
					<div slot="header" class="clearfix flex flex-b cardHeader">
						<h4>营收排行</h4>
						<div class="flex">
							<el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
								@change="ysRankTimeChange" value-format='yyyy-MM-dd' v-model="dataForm.times2"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="flex flex-b" style="margin-bottom: 30px;">
						<h3>会员销售排行</h3>
						<h3>总销售额：{{rank.member.all}}</h3>
					</div>
					<div class="flex flex-b progress" v-for="item in rank.member.list">
						<div class="ptitle">{{item.name}}</div>
						<div style="width: 500px;" class="hyxs">
							<el-progress color="#0099ff" :format='format' :stroke-width='20'
								:percentage="item.price"></el-progress>
						</div>
					</div>

					<div class="flex flex-b" style="margin: 60px 0 30px 0;">
						<h3>培训销售排行 Top 5</h3>
					</div>
					<div class="flex flex-b progress" v-for="item in rank.train.list">
						<div class="ptitle">{{item.name}}</div>
						<div style="width: 500px;">
							<el-progress color="#ff7a8c" :format='format1' :stroke-width='20'
								:percentage="item.price"></el-progress>
						</div>
					</div>

					<div class="flex flex-b" style="margin: 60px 0 30px 0;">
						<h3>课程销售排行 Top 5</h3>
					</div>
					<div class="flex flex-b progress" v-for="item in rank.course.list">
						<div class="ptitle">{{item.name}}</div>
						<div style="width: 500px;">
							<el-progress color="#63a103" :format='format2' :stroke-width='20'
								:percentage="item.score"></el-progress>
						</div>
					</div>
				</el-card>
			</div>
		</div>


		<BillDetail :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog" @confirm="confirmDialog">
		</BillDetail>
	</div>
</template>

<script>
	import BillDetail from "./components/BillDetail.vue"
	import * as echarts from 'echarts';
	import operations from "@/mixins/operations";
	import {
		getBillStat,
		getAnalyze,
		getRank
	} from "@/api/statics"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				dataForm: {
					start_time: '',
					end_time: '',
					staticTimes: '',
					type: '',
					type1: '',
					times: '',
					times1: '',
					start_time_ys: '',
					end_time_ys: '',
					start_time_sy: '',
					end_time_sy: '',
					start_time_ys_rank: '',
					end_time_ys_rank: '',
					times2: '',
				},
				activeName: 'first',
				tabPosition: '',
				dateTime: '',
				value: '',
				value1: '',
				options: [{
					value: 1,
					label: '月度'
				}, {
					value: 2,
					label: '日度'
				}, ],
				staticsData: [],
				selectForm: {},
				editdialogVisible: false,
				train_order_num: [],
				member_order_num: [],
				train_order_price: [],
				member_order_price: [],
				years: [],
				years1: [],
				rank: {
					member: {
						list: [],
						all: 0
					},
					train: {
						list: [],
						all: 0
					},
					course: {
						list: [],
						all: 0
					}
				}
			};
		},
		components: {
			BillDetail
		},
		mounted() {
			this.getBillStat()
			this.getAnalyzeYs()
			this.getAnalyzeSy()
			this.getRank()
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			//营收排行
			async getRank() {
				const {
					status,
					data
				} = await getRank({
					start_time: this.dataForm.start_time_ys_rank,
					end_time: this.dataForm.end_time_ys_rank
				});
				if (status !== 200) return;
				this.rank = data.result
			},
			ysRankTimeChange(e) {
				if (e) {
					this.dataForm.start_time_ys_rank = e[0]
					this.dataForm.end_time_ys_rank = e[1]
				} else {
					this.dataForm.start_time_ys_rank = ''
					this.dataForm.end_time_ys_rank = ''
				}
				this.getRank()
			},
			changeType(e) {
				this.dataForm.type = e
				this.dataForm.start_time_ys = ''
				this.dataForm.end_time_ys = ''
				this.dataForm.times = ''
				this.getAnalyzeYs()
			},
			changeType1(e) {
				this.dataForm.type1 = e // 修正：设置 type1
				this.dataForm.start_time_sy = ''
				this.dataForm.end_time_sy = ''
				this.dataForm.times1 = ''
				this.getAnalyzeSy()
			},
			ysTimesChange(e) {
				this.dataForm.type = ''
				if (e) {
					this.dataForm.start_time_ys = e[0]
					this.dataForm.end_time_ys = e[1]
				} else {
					this.dataForm.start_time_ys = ''
					this.dataForm.end_time_ys = ''
				}
				this.getAnalyzeYs()
			},
			async getAnalyzeYs() {
				let postData = {}
				if (this.dataForm.type) {
					postData = {
						type: this.dataForm.type
					}
				} else {
					postData = {
						start_time: this.dataForm.start_time_ys,
						end_time: this.dataForm.end_time_ys,
					}
				}
				const {
					status,
					data
				} = await getAnalyze(postData);
				if (status !== 200) return;
				this.train_order_num = data.result.train_order_num
				this.member_order_num = data.result.member_order_num
				this.years = data.result.date
				this.initChart()
			},
			syTimesChange(e) {
				if (e) {
					this.dataForm.start_time_sy = e[0]
					this.dataForm.end_time_sy = e[1]
				} else {
					this.dataForm.start_time_sy = ''
					this.dataForm.end_time_sy = ''
				}
				this.getAnalyzeYs()
			},
			async getAnalyzeSy() {
				let postData = {}
				if (this.dataForm.type1) {
					postData = {
						type: this.dataForm.type1 // 修正：使用 type1
					}
				} else {
					postData = {
						start_time: this.dataForm.start_time_sy, // 修正：使用 start_time_sy
						end_time: this.dataForm.end_time_sy, // 修正：使用 end_time_sy
					}
				}
				const {
					status,
					data
				} = await getAnalyze(postData);
				if (status !== 200) return;
				this.member_order_price = data.result.member_order_price
				this.train_order_price = data.result.train_order_price
				this.years1 = data.result.date
				this.initChart1()
			},
			closeDialog(row) {
				this.editdialogVisible = false;
			},
			confirmDialog(row) {
				this.editdialogVisible = false
			},
			changeDays(e) {
				// 获取今天0点的时间戳，作为计算的基准点[2](@ref)
				const todayStartTime = new Date(new Date().toLocaleDateString()).getTime();
				const oneDayMilliseconds = 24 * 60 * 60 * 1000; // 一天的毫秒数

				// 计算各时间范围
				const timeRanges = {
					// 昨天：从今天0点往前推1天到往前推1秒[2](@ref)
					yes: {
						start: new Date(todayStartTime - oneDayMilliseconds),
						end: new Date(todayStartTime - 1) // 昨天23:59:59.999
					},
					// 近7天：从今天0点往前推7天到往前推1秒[2,3](@ref)
					week: {
						start: new Date(todayStartTime - 7 * oneDayMilliseconds),
						end: new Date(todayStartTime - 1)
					},
					// 近30天：从今天0点往前推30天到往前推1秒[2,3](@ref)
					month: {
						start: new Date(todayStartTime - 30 * oneDayMilliseconds),
						end: new Date(todayStartTime - 1)
					}
				};

				// 格式化输出结果
				const result = {};
				for (const range in timeRanges) {
					result[range] = {
						startTime: this.formatDate(timeRanges[range].start),
						endTime: this.formatDate(timeRanges[range].end)
					};
				}
				this.dataForm.start_time = result[e].startTime
				this.dataForm.end_time = result[e].endTime
				this.dataForm.staticTimes = [new Date(this.dataForm.start_time), new Date(this.dataForm.end_time)]
				this.getBillStat()
			},
			staticTimesChange(e) {
				this.tabPosition = ''
				if (e) {
					this.dataForm.start_time = e[0]
					this.dataForm.end_time = e[1]
				} else {
					this.dataForm.start_time = ''
					this.dataForm.end_time = ''
				}
				this.getBillStat()
			},
			tradingTimesChange(e) {
				if (e) {
					this.dataForm.start_time = e[0]
					this.dataForm.end_time = e[1]
				} else {
					this.dataForm.start_time = ''
					this.dataForm.end_time = ''
				}
				this.getBillStat()
			},
			//统计
			async getBillStat() {
				const {
					status,
					data
				} = await getBillStat({
					start_time: this.dataForm.start_time,
					end_time: this.dataForm.end_time
				});
				if (status !== 200) return;
				this.staticsData = data.result
			},
			format(percentage) {
				return `${percentage}`;
			},
			format1(percentage) {
				return `${percentage}元`;
			},
			format2(percentage) {
				return `${percentage}积分`;
			},
			//营收统计
			initChart() {
				const chartDom = this.$refs.chart;
				const myChart = echarts.init(chartDom);

				const option = {
					title: {
						text: '',
						left: 'center',
						top: 0
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							let result = params[0].axisValue + '<br/>';
							params.forEach(item => {
								result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
							});
							return result;
						}
					},
					legend: {
						data: ['会员订单数', '培训订单数'],
						left: 'left',
						icon: 'circle',
						itemWidth: 8,
						itemHeight: 8,
						textStyle: {
							color: '#333',
							fontSize: 12
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: '20%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: this.years,
						name: '',
						axisLabel: {
							textStyle: {
								color: '#999' // 设置 X 轴文字颜色为橙红色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						}
					},
					yAxis: {
						type: 'value',
						name: '',
						interval: 250,
						axisLabel: {
							formatter: '{value}'
						},
						splitLine: {
							lineStyle: {
								color: '#eee'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#999' // 设置 X 轴文字颜色为橙红色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						}
					},
					series: [{
							name: '会员订单数',
							type: 'line',
							data: this.member_order_num,
							itemStyle: {
								color: '#5470C6'
							},
							smooth: false,
							symbol: 'none',
						},
						{
							name: '培训订单数',
							type: 'line',
							data: this.train_order_num,
							itemStyle: {
								color: '#91CC75'
							},
							smooth: false,
							symbol: 'none',
						}
					]
				};

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});
			},
			//收入分析
			initChart1() {
				const chartDom = this.$refs.chart1;
				const myChart = echarts.init(chartDom);

				// 添加调试信息
				console.log('收入分析数据:', {
					x轴: this.years1,
					会员收入: this.member_order_price,
					培训收入: this.train_order_price
				});

				const option = {
					title: {
						text: '',
						left: 'center'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							let result = params[0].axisValue + '<br/>';
							params.forEach(item => {
								result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
							});
							return result;
						}
					},
					legend: {
						data: ['会员收入', '培训收入'],
						left: 'left',
						icon: 'circle',
						itemWidth: 8,
						itemHeight: 8,
						textStyle: {
							color: '#333',
							fontSize: 12
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.years1,
						axisLabel: {
							textStyle: {
								color: '#999'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value}'
						},
						axisLabel: {
							textStyle: {
								color: '#999'
							},
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							lineStyle: {
								color: '#eee'
							}
						},
					},
					series: [{
							name: '会员收入',
							type: 'bar',
							barWidth: '30%',
							data: this.member_order_price,
							itemStyle: {
								color: '#5470C6'
							}
						},
						{
							name: '培训收入',
							type: 'bar',
							barWidth: '30%',
							data: this.train_order_price,
							itemStyle: {
								color: '#91CC75'
							}
						}
					]
				};

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});

				// 返回 myChart 实例，便于调试
				return myChart;
			},
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需加1并补零
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.title {
		font-size: 16px;
		color: #999;
	}

	.val {
		font-size: 38px;
		color: #000;
		font-weight: 600;
	}

	.card {
		padding: 20px 0;
		position: relative;
		border-radius: 10px;
	}

	.br-10px {
		border-radius: 10px;
	}

	.mxbtn {
		position: absolute;
		right: 20px;
		top: 20px;
		font-size: 16px;
		color: #02aef1;
		font-weight: 600;
	}

	.chart-container {
		width: 100%;
		box-sizing: border-box;
	}

	/deep/ .el-card__header {
		background-color: #f9f9f9;
	}

	.headCard {
		/deep/ .el-card__header {
			background-color: transparent;
			padding: 10px 20px;
		}

		/deep/ .el-tabs__nav-wrap::after {
			background-color: transparent;
		}

		/deep/ .el-tabs__item {
			height: auto;
			line-height: 30px;
			font-size: 16px;
			font-weight: 600;
		}

		/deep/ .el-tabs__header {
			margin: 0;
		}
	}

	.ptitle {
		color: #616161;
		font-size: 14px;
	}

	.progress {
		margin-top: 30px;
	}

	/deep/ .el-progress__text {
		font-size: 14px !important;
		margin-left: 10px !important;
	}

	.hyxs {
		/deep/ .el-progress-bar__outer {
			border-radius: 0px;
		}

		/deep/ .el-progress-bar__inner {
			border-radius: 0px;
		}

		/deep/ .el-progress-bar__innerText {
			font-size: 14px !important;
			color: #fff !important;
		}
	}

	::v-deep .el-progress {
		display: flex;
		align-items: center;
	}

	::v-deep .el-progress__text {
		white-space: nowrap;
	}
</style>